// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2241":"9259f7f1235f3bdd","2485":"56deee5e215d5431","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"f01407468f07465e","9312":"402e06aeac36be63","9700":"d3dc3f3c1c42f3ca"}[chunkId] + ".css";
};